<h1 class="accent-background-element">Generate Zip Lookup Table</h1>

<mat-dialog-content>
  @if ((loaded | async) ===true) {
    <p>Generate new zip lookup table for
    {{countries}}?</p>
  }


  @if ((loaded | async) ===false) {
    <div class="spinner-container">
      <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions >
  <div class="spacer"></div>
  @if ((loaded | async) ===true) {
    <button  mat-raised-button color="accent" (click)="onSubmit()" [disabled]="isDisabledButton()">Generate</button>
  }
</mat-dialog-actions>